import { isNil } from "lodash";
import React, { FC, useEffect, useRef } from "react";
import { useIntl } from "react-intl";

import { Icon } from "~/ui/components/icons";
import { TextInput } from "~/ui/components/inputs";
import { useChatMessageToEdit } from "~/ui/context";

export const ConversationMessageInput: FC<{
  message: string;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  sendMessage: () => void;
}> = ({ message, setMessage, sendMessage }) => {
  const intl = useIntl();
  const { messageToEdit, setMessageToEdit } = useChatMessageToEdit();

  const handleMessageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(e.target.value);
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  const handleEditMessageClose = () => {
    setMessageToEdit(null);
    setMessage("");
  };

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!isNil(messageToEdit) && inputRef.current) {
      inputRef.current.focus();
    }
  }, [messageToEdit]);

  return (
    <TextInput
      bg="light"
      placeholder={intl.formatMessage({
        defaultMessage: "Message",
        id: "T7Ry38",
      })}
      value={message}
      onChange={handleMessageChange}
      onKeyDown={handleKeyDown}
      wrapperClassname="w-100"
      autoFocus={!isNil(messageToEdit)}
      beforeClassName="pd-none"
      ref={inputRef}
      before={
        !isNil(messageToEdit) && (
          <Icon
            size="lg"
            icon={["fal", "times"]}
            onClick={handleEditMessageClose}
            className="text-success-light pointer bg-dark borderR-02 h-full w-40px pd-l-md pd-r-md"
          />
        )
      }
    />
  );
};
